import Vue from "vue";
import Vuex from "vuex";
import { ToastPlugin } from "bootstrap-vue";
import workflowStore from "./stores/workflowStore.js";
import actorStore from "./stores/actorStore.js";
import requestStore from "./stores/requestStore.js";
import authenticationStore from "./stores/authenticationStore.js";
import menuStore from "./stores/menuStore.js";
import logsStore from "./stores/logsStore.js";
import scoreStore from "./stores/scoreStore.js";
import documentStore from "./stores/documentStore.js";
import permissionsStore from "./stores/permissionsStore.js";
import requirementStore from "./stores/requirementStore.js";
import familyStore from "./stores/familyStore.js";
import familyRequirementsStore from "./stores/familyRequirementsStore";
import companyStore from "./stores/companyStore.js";
import companyGroupStore from "./stores/companyGroupStore.js";
import supplierStore from "./stores/supplierStore.js";
import supplierOfferStore from "./stores/supplierOfferStore.js";
import supplierClientBankStore from "./stores/supplierClientBankStore.js";
import supplierClientContatStore from "./stores/supplierClientContactStore.js";
import invitesStore from "./stores/invitesStore.js";
import integrationStore from "./stores/integrationStore.js";
import userStore from "./stores/userStore.js";
import clientStore from "./stores/clientStore.js";
import vendorsListStore from "./stores/vendorsListStore.js";
import materialStore from "./stores/materialStore.js";
import requirementResponseStore from "./stores/requirementResponseStore.js";
import expiredRequirementStore from "./stores/expiredRequirementStore.js";
import offersStore from "./stores/offersStore.js";
import requirementGroupStore from "./stores/requirementGroupStore.js";
import reportStore from "./stores/reportStore.js";
import supplierClientStore from "./stores/supplierClientStore.js";
import emailStore from "./stores/emailStore.js";
import noAuthStore from "./stores/noAuthStore.js";
import maskStore from "./stores/maskStore.js";
import configurationStore from "./stores/configurationStore.js";
import bankStore from "./stores/bankStore.js";
import exportStore from "./stores/exportStore.js";
import saneamentoLoadStore from "./stores/saneamentoLoadStore.js";
import blackListStore from "./stores/blackListStore.js";
import standardListStore from "./stores/standardListStore.js";
import translationStore from "./stores/translationStore.js";
import languageStore from "./stores/languageStore.js";

Vue.use(Vuex);
Vue.use(ToastPlugin);

let stores = [
	workflowStore,
	actorStore,
	requestStore,
	authenticationStore,
	menuStore,
	logsStore,
	scoreStore,
	documentStore,
	permissionsStore,
	requirementStore,
	familyStore,
	familyRequirementsStore,
	companyStore,
	companyGroupStore,
	supplierOfferStore,
	supplierClientBankStore,
	supplierClientContatStore,
	invitesStore,
	integrationStore,
	userStore,
	clientStore,
	vendorsListStore,
	materialStore,
	requirementResponseStore,
	expiredRequirementStore,
	offersStore,
	requirementGroupStore,
	reportStore,
	supplierStore,
	supplierClientStore,
	emailStore,
	noAuthStore,
	maskStore,
	configurationStore,
	bankStore,
	exportStore,
	saneamentoLoadStore,
	blackListStore,
	standardListStore,
	clientStore,
	translationStore,
	languageStore,
];

let actions = Object.fromEntries(stores.flatMap((store) => Object.entries(store.actions)));
let mutations = Object.fromEntries(stores.flatMap((store) => Object.entries(store.mutations)));
let state = Object.fromEntries(stores.flatMap((store) => Object.entries(store.state)));
let getters = Object.fromEntries(stores.flatMap((store) => Object.entries(store.getters)));

let mainStore = {
	actions,
	mutations,
	state,
	getters
};

export default new Vuex.Store({
	state: mainStore.state,
	mutations: mainStore.mutations,
	actions: mainStore.actions,
	getters: mainStore.getters
});
